import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { sectionIfSticky, section } from "./Section.css.mjs";
const Section = (props) => /* @__PURE__ */ jsx(
  Box,
  {
    style: { gridArea: props.gridArea },
    className: [props.isSticky ? sectionIfSticky : section],
    background: props.background,
    children: props.children
  }
);
export {
  Section
};
